const actionCreators = {
  setPendingState(pendingState, status) {
    return {
      type: 'SET_PENDING_STATE',
      payload: {
        pendingState,
        status,
      },
    };
  },
};

export {
  actionCreators,
};
